<template>
    <div class="app">
        <UserProfile/>
        <ModalDialog/>
        <UiInfoScreen/>
        <UiMessage/>
        <Header/>
        <Content/>
        <Footer/>
    </div>
</template>

<script>
import Header  from '@/components/layout/Header'
import Footer  from '@/components/layout/Footer'
import Content from '@/components/layout/Content'
import UiMessage from "@/components/layout/parts/messages/UiMessage.vue";
import ModalDialog from "@/components/layout/parts/ModalDialog.vue";
import UiInfoScreen from "@/components/layout/parts/infoscreens/UiInfoScreen.vue";
import UserProfile from "@/components/layout/parts/userprofile/UserProfile.vue";

export default {
    name      : 'App',
    components: { UserProfile, UiInfoScreen, ModalDialog, UiMessage, Content, Footer, Header }
}
</script>

<style lang="less">
@import '~@/less/reset.less';
@import '~@/less/ui.less';
</style>